import React from "react";
import EntityModal from "../index";
import { compose } from "react-recompose";
import { ConvertleadBotFormContainer, DealsContainer } from "@containers";
import ConvertLeadBotForm from "../../forms/convertLeadBot";

const ConvertLeadBotFormModal = props => <EntityModal {...{ ...props, Container: ConvertLeadBotForm }} />;

export default compose(ConvertleadBotFormContainer, DealsContainer)(ConvertLeadBotFormModal);
